import React, { useContext, useEffect, useState } from "react";
import OpenRegDtls from "./OpenRegDtls";
import CloseRegDtls from "./CloseRegDtls";
import Payments from "./Payments";
import { Model, UseForm } from "../../../../../hooks";
import {
  BGNestedObjToFromData,
  lsGet,
  lsUpdate,
} from "../../../../../hooks/Method";
import { Alert, Snackbar } from "../../../../../layout";
import { action, API, controller } from "../../../../../api/api";
import RegisterForm from "../OpenReg/RegisterForm";
import { Container, Grid } from "@mui/material";
import { AppContext } from "../../../../../App";
import { Input } from "../../../../../controls";
import { toast } from "react-toastify";

const CloseReg = () => {
  const openReg = lsGet("activeReg");
  const { authUser } = useContext(AppContext);
  const [activeReg, setActiveReg] = useState(openReg);
  const [loading, setLoading] = useState(false);
  const { SellRegisterMdl } = Model();
  const [txns, setTxns] = useState([]);
  const [totals, setTotals] = useState({
    expected: 0,
    counted: 0,
    differences: 0,
  });

  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "error",
    msg: "",
  });

  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const { values, setValues, errors, setErrors, resetFormControls } =
    UseForm(SellRegisterMdl);

  useEffect(() => {
    activeReg?.id &&
      API(controller.CashMgmt + action.GetAllByReg).getById(
        activeReg.id,
        (res) => {
          if (res.status === 200) setTxns([...res.result]);
        }
      );
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleNote = (e) => {
    setValues((j) => ({ ...j, closingNotes: e.target.value }));
  };

  const validateForm = () => {
    let temp = {};
    values.sellRegPayments &&
      values.sellRegPayments.forEach((payment) => {
        var expectedAmt =
          payment.payTypeId === 1 && payment.payTypeName === "Cash"
            ? payment.expected + values.cashInDrawer
            : payment.expected;

        if (expectedAmt > 0 && !payment.counted)
          temp[payment.payTypeId + "counted"] = "Amount is required";
      });

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = () => {
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        if (res && res.status === 200) {
          lsUpdate("activeReg", { ...res.result });
          setActiveReg({ ...res.result });

          resetFormControls();

          toast.success("The register has been closed successfully.");
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
        setLoading(false);
      };

      API(controller.SellReg + action.CloseReg).post(
        BGNestedObjToFromData({
          ...values,
          closingTime: new Date().toISOString(),
        }),
        onComplete
      );
    } else toast.error("Please enter the amount for the highlighted fields.");
  };

  const handleRegOpenSuccess = (val) => {
    setActiveReg({ ...val });
  };

  return (
    <>
      <Grid container spacing={3}>
        {/* Open Register Form, 
        when activer register will null or active register is closed 
        that time this form will appear  */}

        {(!activeReg || activeReg?.status === 2) && (
          <Grid item xs={12}>
            <Container maxWidth="sm" className="mt-[10px]">
              <RegisterForm
                {...{
                  regCloseable: false,
                  onSuccess: handleRegOpenSuccess,
                }}
              />
            </Container>
          </Grid>
        )}

        {/* Active and closed register details */}
        {activeReg?.id && (
          <>
            <Grid item xs={12}>
              {activeReg.status === 2 ? (
                <CloseRegDtls {...{ activeReg, txns, totals }} />
              ) : (
                <OpenRegDtls {...{ handleSubmit, loading, activeReg }} />
              )}
            </Grid>
            <Grid item xs={12}>
              <Payments
                {...{
                  values,
                  setValues,
                  errors,
                  setErrors,
                  activeReg,
                  txns,
                  setTotals,
                  totals,
                }}
              />
            </Grid>
            {/* This note section will only appear when register will open */}
            {activeReg?.status !== 2 && (
              <Grid item xs={12}>
                <Input
                  placeholder="Write your closing notes..."
                  name="note"
                  value={values.closingNotes}
                  variant="outlined"
                  multiline
                  inputProps={{ maxLength: 500 }}
                  rows={4}
                  onChange={handleNote}
                />
              </Grid>
            )}
          </>
        )}
      </Grid>

      {snackbar && (
        <Snackbar
          autoHideDuration={2000}
          snackbar={snackbar}
          setSnackbar={setSnackbar}
        />
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default CloseReg;
